import { render, staticRenderFns } from "./create.vue?vue&type=template&id=1056ab8e&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=1056ab8e&prod&lang=scss&"
import style1 from "./create.vue?vue&type=style&index=1&id=1056ab8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1056ab8e",
  null
  
)

export default component.exports